const initialState = {
  preference_filters: {},
  hasPreferencesUpdated: false,
};
export default initialState;
